<svg
  width="28"
  height="29"
  viewBox="0 0 28 29"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M23.333 7.49998H19.833V5.16665C19.833 3.87981 18.7865 2.83331 17.4997 2.83331H10.4997C9.21284 2.83331 8.16634 3.87981 8.16634 5.16665V7.49998H4.66634C3.37951 7.49998 2.33301 8.54648 2.33301 9.83331V22.6666C2.33301 23.9535 3.37951 25 4.66634 25H23.333C24.6198 25 25.6663 23.9535 25.6663 22.6666V9.83331C25.6663 8.54648 24.6198 7.49998 23.333 7.49998ZM17.4997 5.16665V7.49998H10.4997V5.16665H17.4997ZM4.66634 9.83331H23.333V14.5H19.833V12.1666H17.4997V14.5H10.4997V12.1666H8.16634V14.5H4.66634V9.83331ZM4.66634 22.6666V16.8333H8.16634V19.1666H10.4997V16.8333H17.4997V19.1666H19.833V16.8333H23.3342V22.6666H4.66634Z"
    fill="currentColor"
  />
</svg>
